module.exports = __webpack_public_path__ + "static/img/pic_VIPYS_02@2x.9f16a35c.png";